import Navbar from '../../../components/Navbar';
import React, { Fragment } from 'react';
import { ListActiveUsers } from './components/ListActiveUsers';

export const ActiveUsers = () => {
  return (
    <Fragment>
      <Navbar />
      <ListActiveUsers />
    </Fragment>
  );
};
